import Vue from 'vue'
import Router from 'vue-router'
// // 产品视图
// import products from '@/views/products/index'
// // import products1 from '@/views/products/index1'
// import products2 from '@/views/products/index2'
// import products3 from '@/views/products/index3'
// import products4 from '@/views/products/index4'
// import agentsprods from '@/views/products/agentsprods'
// import productrule from '@/views/products/productrule'
// // import productprivacy from '@/views/products/productprivacy'

// import productdetail from '@/views/productdetail/index'
// import productdetailall from '@/views/productdetail/index_inner'
// import productdetail1 from '@/views/productdetail/index_inner1'
// import productdetail2 from '@/views/productdetail/index_inner_temp'

// import productdetailb from '@/views/productdetail/index_inner_bottom'
// import productdetailpop from '@/views/productdetail/index_pop'
// import productdetailform from '@/views/productdetail/index_form'

// // 订单视图
// import orderlist from '@/views/mineorders/orderlist'
// import orderdetail from '@/views/mineorders/orderdetail'
// import ordersearch from '@/views/mineorders/ordersearch'
// // 投诉视图
// import complaintlist from '@/views/complaint/complaintlist'
// import complaintsave from '@/views/complaint/complaintsave'

// // 大铁
// import dtu from '@/views/introductions/dtu'
// import f35p from '@/views/introductions/f35p'
// import f35 from '@/views/introductions/f35'
// import f36 from '@/views/introductions/f36'
// import f37 from '@/views/introductions/f37'
// import deviceindex from '@/views/introductions/deviceindex'

// // 信息收集
// import collectionindex from '@/views/collection/index'

// // import HelloWorld from '@/components/HelloWorld'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [ {
    path: '/',
    name: 'index',
    redirect: '/productcards'
  },
  {
    path: '/productprivacy',
    name: 'productprivacy',
    component: () => import('@/views/products/productprivacy'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/productprivacy_yidong',
    name: 'productprivacy_yidong',
    component: () => import('@/views/products/productprivacy_yidong'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/productzeren_yidong',
    name: 'productzeren_yidong',
    component: () => import('@/views/products/productzeren_yidong'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/productrule',
    name: 'productrule',
    component: () => import('@/views/products/productrule'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/productrule_dianxin',
    name: 'productrule_dianxin',
    component: () => import('@/views/products/productrule_dianxin'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  // 广东移动的一些政策
  {
    path: '/gdydrule_one',
    name: 'gdydrule_one',
    component: () => import('@/views/products/gdydrule_one'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/gdydrule_two',
    name: 'gdydrule_two',
    component: () => import('@/views/products/gdydrule_two'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/gdydrule_three',
    name: 'gdydrule_three',
    component: () => import('@/views/products/gdydrule_three'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/gdydrule_four',
    name: 'gdydrule_four',
    component: () => import('@/views/products/gdydrule_four'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/gdydrule_five',
    name: 'gdydrule_five',
    component: () => import('@/views/products/gdydrule_five'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/gdydrule_six',
    name: 'gdydrule_six',
    component: () => import('@/views/products/gdydrule_six'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/gdydrule_seven',
    name: 'gdydrule_seven',
    component: () => import('@/views/products/gdydrule_seven'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/gdydrule_eight',
    name: 'gdydrule_eight',
    component: () => import('@/views/products/gdydrule_eight'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/gdydrule_nine',
    name: 'gdydrule_nine',
    component: () => import('@/views/products/gdydrule_nine'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/productrule_yidong',
    name: 'productrule_yidong',
    component: () => import('@/views/products/productrule_yidong'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/agentsprods',
    name: 'agentsprods',
    component: () => import('@/views/products/agentsprods'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/products',
    name: 'products',
    component: () => import('@/views/products/index'),
    meta: {
      keepAlive: true // 需要被缓存
    }
  },
  {
    path: '/productlist',
    name: 'productlist',
    component: () => import('@/views/products/productlist.vue'),
    meta: {
      keepAlive: true // 需要被缓存
    }
  },
  {
    path: '/productlistxhs',
    name: 'productlistxhs',
    component: () => import('@/views/products/productlistxhs.vue'),
    meta: {
      keepAlive: true // 需要被缓存
    }
  },
  {
    path: '/productcards',
    name: 'productcards',
    component: () => import('@/views/products/productcards.vue'),
    meta: {
      keepAlive: true // 需要被缓存
    }
  },
  {
    path: '/products1',
    name: 'products1',
    component: () => import('@/views/products/index1.vue'),
    meta: {
      keepAlive: true // 需要被缓存
    }
  },
  {
    path: '/products2',
    name: 'products2',
    component: () => import('@/views/products/index2'),
    meta: {
      keepAlive: true // 需要被缓存
    }
  },
  {
    path: '/products3',
    name: 'products3',
    component: () => import('@/views/products/index3'),
    meta: {
      keepAlive: true // 需要被缓存
    }
  },
  {
    path: '/products4',
    name: 'products4',
    component: () => import('@/views/products/index4'),
    meta: {
      keepAlive: true // 需要被缓存
    }
  },
  {
    path: '/products5',
    name: 'products5',
    component: () => import('@/views/products/index5'),
    meta: {
      keepAlive: true // 需要被缓存
    }
  },
  {
    path: '/productdetail',
    name: 'productdetail',
    component: () => import('@/views/productdetail/index'),
    meta: {
      keepAlive: true // 需要被缓存
    }
  },
  {
    path: '/productdetail_first',
    name: 'productdetail1',
    component: () => import('@/views/productdetail/index_inner1'),
    meta: {
      keepAlive: true // 需要被缓存
    }
  },
  {
    path: '/productdetail_temp',
    name: 'productdetail2',
    component: () => import('@/views/productdetail/index_inner_temp'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/productdetail_all',
    name: 'productdetailall',
    component: () => import('@/views/productdetail/index_inner'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/productdetail_bottom',
    name: 'productdetailb',
    component: () => import('@/views/productdetail/index_inner_bottom'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/productdetail_pop',
    name: 'productdetail_pop',
    component: () => import('@/views/productdetail/index_pop'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/productdetail_form',
    name: 'productdetail_form',
    component: () => import('@/views/productdetail/index_form'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/productdetail_formxhs',
    name: 'productdetail_formxhs',
    component: () => import('@/views/productdetail/index_formxhs'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/orderlist',
    name: 'orderlist',
    component: () => import('@/views/mineorders/orderlist'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/orderjd',
    name: 'orderjd',
    component: () => import('@/views/mineorders/orderjd'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/ordersearch',
    name: 'ordersearch',
    component: () => import('@/views/mineorders/ordersearch'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/orderdetail',
    name: 'orderdetail',
    component: () => import('@/views/mineorders/orderdetail'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/complaintsave',
    name: 'complaintsave',
    component: () => import('@/views/complaint/complaintsave'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/complaintlist',
    name: 'complaintlist',
    component: () => import('@/views/complaint/complaintlist'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/orderresult',
    name: 'orderresult',
    component: () => import('@/views/productdetail/result'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/dtu',
    name: 'dtu',
    component: () => import('@/views/introductions/dtu'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/f35p',
    name: 'f35p',
    component: () => import('@/views/introductions/f35p'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/f35',
    name: 'f35',
    component: () => import('@/views/introductions/f35'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/f36',
    name: 'f36',
    component: () => import('@/views/introductions/f36'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/f37',
    name: 'f37',
    component: () => import('@/views/introductions/f37'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/deviceindex',
    name: 'deviceindex',
    component: () => import('@/views/introductions/deviceindex'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/form',
    name: 'form',
    component: () => import('@/views/collection/index'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('@/views/test'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/qhd',
    name: 'qhd',
    component: () => import('@/views/staticpage/qhd'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/sjyl',
    name: 'sjyl',
    component: () => import('@/views/staticpage/sjyl'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/xingxing',
    name: 'xingxing',
    component: () => import('@/views/staticpage/xingka'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/orderconfirm',
    name: 'orderconfirm',
    component: () => import('@/views/orderconfirm/index'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/orderexpress',
    name: 'orderexpress',
    component: () => import('@/views/orderconfirm/orderexpress'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  },
  {
    path: '/zldybackset',
    name: 'zldybackset',
    component: () => import('@/views/utilpage/zhonglianset.vue'),
    meta: {
      keepAlive: false // 需要被缓存
    }
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js